export const API_BASE_URL_DEV = "http://api.mywarehouseonline.com/api/v2";
export const API_BASE_URL_PROD = "https://api.mywarehouseonline.com/api/v2";
export const API_BASE_URL_STG = "http://stage-api.mywarehouseonline.com/api/v1";
export const API_ERROR_MESSAGE = "Something went wrong";
export const DEFAULT_RECORD_LIMIT = 10;
export const API_VERSION = "v2";
export const LOCAL_STORAGE_USER_DATA_NAME = "adminData";
export const NOTIFICATION_TIMER = 300000; // 5 min

export const TOTAL_IMAGE_NUM = 20;
export const INDEX_TO_NAME = {
  0: "one",
  1: "two",
  2: "three",
  3: "four",
  4: "five",
  5: "six",
  6: "seven",
  7: "eight",
  8: "nine",
  9: "ten",
  10: "eleven",
  11: "twelve                                                                                                                                                                                                         ",
  12: "thirteen",
  13: "fourteen",
  14: "fifteen",
  15: "sixteen",
  16: "seventeen",
  17: "eighteen",
  18: "nineteen",
  19: "twenty",
};

export const UPLOAD_ORDERS_STATUS = [
  {
    name: "Uploaded",
    value: "uploaded",
  },
  {
    name: "Approval Pending",
    value: "approval_pending",
  },
  {
    name: "Placed",
    value: "placed",
  },
  {
    name: "Rejected",
    value: "rejected",
  },
  {
    name: "Quotation Requested",
    value: "quotation_requested",
  },
  {
    name: "Confirmed",
    value: "confirmed",
  },
  {
    name: "Packed",
    value: "packed",
  },
  {
    name: "Dispatched",
    value: "dispatched",
  },
  {
    name: "In Transit",
    value: "in_transit",
  },
  {
    name: "Delivered",
    value: "delivered",
  },
];

export const ORDER_STATUS = [
  {
    name: "In Progress",
    value: "in_progress",
  },
  {
    name: "Pending",
    value: "pending",
  },
  {
    name: "Completed",
    value: "completed",
  },
  {
    name: "Uploaded",
    value: "uploaded",
  },
  {
    name: "Approval Pending",
    value: "approval_pending",
  },
  {
    name: "Rejected",
    value: "rejected",
  },
  {
    name: "Placed",
    value: "placed",
  },
  {
    name: "Accepted",
    value: "accepted",
  },
  {
    name: "Rejected",
    value: "rejected",
  },
  {
    name: "Packed",
    value: "packed",
  },
  {
    name: "Dispatched",
    value: "dispatched",
  },
  {
    name: "In Transit",
    value: "in_transit",
  },
  {
    name: "Delivered",
    value: "delivered",
  },
  {
    name: "Failed Payment",
    value: "payment_failed",
  },
  {
    name: "Cancelled",
    value: "cancelled",
  },
];

export const AGENT_VERIFICATION_STATUS = [
  {
    name: "Completed",
    value: 1,
  },
  {
    name: "Not Completed",
    value: 2,
  },
];

export const DELIVERY_CHARGE = [
  {
    name: "Charge by ton",
    value: 1,
  },
  {
    name: "Charge by KM",
    value: 2,
  },
];

export const NON_TILE_CHARGE = [
  {
    name: "Amount",
    value: 1,
  },
  {
    name: "Percentage",
    value: 2,
  },
];

export const USER_TYPES = [
  {
    name: "Admin",
    value: 1,
  },
  {
    name: "Franchise",
    value: 3,
  },
  {
    name: "Salesman",
    value: 4,
  },
];
